import styled, { css } from 'styled-components';
import { Typ35 } from 'dc/Typ';
import Btn021 from 'dc/Btn021';

type WrapperProps = {
  noBorder?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 24px 38px;
  border-radius: 16px;
  ${props =>
    !props.noBorder &&
    css`
      border: 1px solid #cfd8dc;
    `};
`;

export const Title = styled(Typ35)`
  text-align: center;
  width: 100%;
  margin-bottom: 14px;
`;

export const Button = styled(Btn021)`
  width: 100%;
`;
